import React from "react";
import Meta from "./../components/Meta";
import PricingSection from "./../components/PricingSection";
import Navbar from "../components/Navbar";

function PricingPage(props) {
  return (
    <>
      <Meta title="Pricing" />
      <Navbar
        color="default"
        logo="https://drive.google.com/uc?export=view&id=1idL8ixbXPQ6cFrmYenBkUfmz2X9_MkFi"
        logoInverted="https://drive.google.com/uc?export=view&id=1FDW3ksZ8tqRXneFsRPHFN4Gor8X1kfEA"
      />
      <PricingSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Pricing"
      />
    </>
  );
}

export default PricingPage;
